import { FormatIcu } from '@tolgee/format-icu';
import { BackendFetch, DevTools, Tolgee } from '@tolgee/react';

export const localeOptions = [
  ['en-US', '🇺🇸 English'],
  ['en-GB', '🇬🇧 English'],
  ['en-CA', '🇨🇦 English'],
  ['en-AU', '🇦🇺 English'],
  ['es-ES', '🇪🇸 Español'],
  ['es-MX', '🇲🇽 Español'],
  ['es-US', '🇺🇸 Español'],
  ['ar-AE', '🇦🇪 العربية'],
  ['ar-EG', '🇪🇬 العربية'],
  ['ar-SA', '🇸🇦 العربية'],
  ['fr-FR', '🇫🇷 Français'],
  ['de-DE', '🇩🇪 Deutsch'],
  ['it-IT', '🇮🇹 Italiano'],
  ['pt-BR', '🇧🇷 Português'],
  ['ko-KR', '🇰🇷 한국어'],
  ['hi-IN', '🇮🇳 हिंदी'],
  ['id-ID', '🇮🇩 Indonesia'],
  ['uk-UA', '🇺🇦 Українська'],
  ['nb-NO', '🇳🇴 Norsk'],
  ['hu-HU', '🇭🇺 Magyar'],
  ['pl-PL', '🇵🇱 Polski'],
  ['ru-KZ', '🇰🇿 Русский'],
];

export const SupportedLocales = [...localeOptions.map(([key]) => key)];

export const DefaultLocale = 'en-US';

export const tolgee = Tolgee()
  .use(DevTools())
  .use(FormatIcu())
  .use(
    BackendFetch({
      // We async client side fetch the translations from the server. This reduces the bundle size. TODO = move this to CDN during CICD
      prefix: `${process.env.NEXT_PUBLIC_BASE_URL}/i18n`,
    }),
  )
  .init({
    defaultLanguage: DefaultLocale,
    // for dev mode
    apiUrl: process.env.NEXT_PUBLIC_TOLGEE_API_URL,
    apiKey: process.env.NEXT_PUBLIC_TOLGEE_API_KEY,
    availableLanguages: [...localeOptions.map(([value]) => value)],
    // for production and server
    staticData: {},
  });
